/**
 * Maintenance notification from 12h00 March 12th, 2022 to 17h March 13th, 2022
 */
export const notiMaintenanceFrom2022March12thTo2022March13th = {
  fromDateTime: new Date(2022, 2, 12, 12, 0),
  toDateTime: new Date(2022, 2, 13, 17, 0),
}
